export default __webpack_public_path__ + "static/media/Detect_Valkyrie.9d50e52b.svg";